import React from 'react';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';
import request from '../../helpers/request';
import debounce from '../../helpers/debounce';
import SimplePage from '../common/SimplePage';
import vendorConfig from './config/vendorConfig';
import setViewTitle from '../../helpers/setViewTitle';
import moment from 'moment';

var VendorList = createReactClass({
  actions: [],

  getInitialState() {
    return {
      vendors: [],
      actions: [
        {title: 'Neuer Lieferant', to: '/vendors/new', claim: 'vendors:write'}
      ]
    };
  },

  componentWillMount() {
    setViewTitle('Lieferantenübersicht');
    this.debouncedReloadData = debounce(this.reloadData, 300);
  },

  componentDidMount() {
    this.reloadData();
  },

  reloadData() {
    request.get({
      url: vendorConfig.apiUrl,
      data: this.createFilterParams(),
      success: data => {
        if (this.isMounted()) {
          this.setState({
            vendors: data
          });
        }
      }
    });
  },

  createFilterParams() {
    return {
      term: this.state.vendorNameFilter,
    };
  },

  applyFilter(e) {
    this.setState({
      vendorNameFilter: e.target.value
    }, () => this.debouncedReloadData());
  },

  render() {

    var vendorsList = this.state.vendors.map(vendor =>
      <tr key={vendor.id}>
          <td><Link to={`/vendors/${vendor.id}`}>{vendor.name}</Link></td>
          <td><Link to={`/vendors/${vendor.id}`}>{vendor.isSyncVendor ? vendor.syncName : 'Lagerpark'}</Link></td>
          <td><Link to={`/vendors/${vendor.id}`}>{this.getDateString(vendor.lastImportDate)}</Link></td>
      </tr>
    );

    return (
      <SimplePage title="Lieferantenübersicht" icon="paper-plane-o" actions={this.state.actions}>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Angelegt in</th>
                <th>Letzter Import</th>
              </tr>
              <tr>
                <th>
                  <input type="text" className="form-control" placeholder="Filter..." onChange={this.applyFilter} />
                </th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {vendorsList}
            </tbody>
          </table>
        </div>
      </SimplePage>
    );
  },

  getDateString(jsonDate) {
    if (!jsonDate) {
      return;
    }

    return moment(jsonDate).format('DD.MM.YYYY HH:mm:ss');
  }

});

export default VendorList;



// WEBPACK FOOTER //
// ./src/components/vendors/VendorList.js